import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetDeleteIconService {

  constructor() { }

  public deleteIconClickedSource = new Subject<number>();
  deleteIconClicked$ = this.deleteIconClickedSource.asObservable();

  triggerDeleteClick(params: any) {
    this.deleteIconClickedSource.next(params);
  }
}
